import React, { useState, useEffect } from "react";
//import { useMemo } from "react";
import { Link } from "react-router-dom";
import "new_components/Insights/InsightDetails.scss";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";
import axios from "axios";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";
import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
//import HomeBottomBanner from "new_components/Home/HomeBottomBanner";
import PreLoad from "new_components/PreLoad/PreLoad";
import { useParams } from "react-router-dom";
//import linkedinIcon from "../../new_assets/new_images/SocialMediaIcons/linkedin.png";
//import instagramIcon from "../../new_assets/new_images/SocialMediaIcons/instagram.png";
//import icons1 from "../../new_assets/new_images/SocialMediaIcons/Icons-1.png";
// import icons2 from "../../new_assets/new_images/SocialMediaIcons/Icons-2.png";
//import icons from "../../new_assets/new_images/SocialMediaIcons/Icons.png";
import { IoShareSocial } from "react-icons/io5";

const InsightsDetails = () => {
  return (
    <>
      <ScrollToTopDefault />
      <ProgressCircle />
      <Header />
      <Body />
      <Footer />
    </>
  );
};

const Body = () => {
  return (
    <div>
      <InsightDetailSection />
      <ContactUsSection />
      {/* <HomeBottomBanner /> */}
    </div>
  );
};

const InsightDetailSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { slug } = useParams();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrls.insightsBlog}/${slug}`);

        if (response.data.status === "success") {
          setData(response.data.data);
          console.log("Detail Data ", response.data.data);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (err) {
        setError(err.message || "An error occurred while fetching data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  if (loading) {
    return <PreLoad />;
  }

  if (error) {
    return (
      <section className="flat-section pt-0">
        <div className="container text-center">
          <p className="text-danger">{error}</p>
        </div>
      </section>
    );
  }

  return (
    <section className="flat-section pt-5 pb-3">
      <div className="container">
        {/* <div
          className="row align-items-center justify-content-center wow fadeInUp insightsdetailbanner"
          style={{
            backgroundImage: `url(${Image_Base_URL + data.image})`,
          }}
          data-wow-delay=".2s"
        > */}
        <div className="card-details-logo-wrapper pb-2">
          <img
            src={Image_Base_URL + (data.card_image || "No image available")}
            alt={data.card_title}
            className=""
          />
        </div>
        <div
          className="row align-items-center justify-content-center wow fadeInUp"
          data-wow-delay=".2s"
        >
          <div className="col-12 mb-2 pt-md-4 pt-2">
            <h6 className="content text-start fw-bolder mb-2">
              {" "}
              {data.card_title}
            </h6>
            <h6 className="content text-start fw-normal mb-2">
              {data.posted_by}
            </h6>
            {data.created_at && (
              <div className="text-start  mb-2">
                {new Date(data.created_at).toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
                })}
              </div>
            )}
            <div
              className="note-home body-2 mb-3 pt-md-4 pt-2"
              dangerouslySetInnerHTML={{
                __html: data?.blog_content || "No description available.",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

function ContactUsSection() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(apiUrls.insightContactCta) // Replace with the actual API endpoint
      .then((response) => {
        setData(response.data.data);
      })
      .catch((err) => {
        setError("Failed to load contact information. Please try again later.");
      });
  }, []);
  const Shareviamedia = async (e) => {
    e.preventDefault();

    // This check triggers the native "Open" behavior of the OS
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check out this blog !",
          url: window.location.href, // This provides the link to the share sheet
        });
      } catch (err) {
        console.log("Share interface closed by user.");
      }
    } else {
      // If the browser doesn't support native sharing.
      console.log("Native sharing not supported on this browser.");
    }
  };
  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (!data) {
    return (
      <div className="loading-message">
        <PreLoad />
      </div>
    );
  }

  return (
    <div className="insight-details-page-wrapper">
      <section className="flat-section flat-contact contactus-body pt-0">
        <div className="container">
          <div className="row align-items-stretch justify-content-between">
            <div className="col-lg-9 d-flex ">
              <div className="contact-info box w-100 ">
                <h6
                  className="fw-bold mb-3"
                  dangerouslySetInnerHTML={{
                    __html: data?.text || "Contact Us!",
                  }}
                />
                <Link
                  to={data.button_url}
                  className="tf-btn btn-view primary hover-btn-view  "
                >
                  {data.button_text}{" "}
                  <span className="icon icon-arrow-right2"></span>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 d-flex ">
              <div
                className="contact-info share-contact d-flex flex-column align-items-start w-100 p-4 justify-content-center share-media "
                onClick={Shareviamedia}
              >
                <div className="mb-4">
                  <IoShareSocial />
                </div>

                <h6 className="fw-bold m-0">Share Via Social Media</h6>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default InsightsDetails;
